const defaultThemeDefaultProps = {
  theme: {
    color: {
      neutral: {
        onSurfaceSubdued2: 'none',
        surfaceDefault: 'none',
      },
    },
  },
}

export const getThemeDefaultProps = () => defaultThemeDefaultProps
